export default AlertManager

/** @ngInject */
function AlertManager() {
    return {
        alerts: [],
        addAlert(alert) {
            return this.alerts.push(alert)
        },
        closeAlert(index) {
            return this.alerts.splice(index, 1)
        },
        clearAlerts() {
            return this.alerts.splice(0, this.alerts.length)
        },
        success(msg, timeout, detail) {
            return this.addAlert({ type: 'success', timeout, msg, detail })
        },
        error(msg, timeout, detail) {
            return this.addAlert({ type: 'error', timeout, msg, detail })
        },
    }
}



// WEBPACK FOOTER //
// ./src/services/alerts/alerts.js